interface IAuth {
	accessToken: string;
	infoUser: {
		name: string;
		email: string;
		adm: boolean;
		managerWebAccess: boolean;
	};
}

interface IPersistenceAuth {
	token: string;
	infoUser: {
		name: string;
		email: string;
		adm: boolean;
		manager_web_access: boolean;
	};
}

class Mapper {
	toDomain(persistenceAuth: IPersistenceAuth): IAuth {
		return {
			accessToken: persistenceAuth.token,
			infoUser: {
				name: persistenceAuth.infoUser.name,
				email: persistenceAuth.infoUser.email,
				adm: persistenceAuth.infoUser.adm,
				managerWebAccess: persistenceAuth.infoUser.manager_web_access
			}
		};
	}
}

export const AuthMapper = new Mapper();
